import React from 'react'
import PropTypes from 'prop-types'
import { Grid, IconButton, MenuItem, Select, Typography, makeStyles } from '@material-ui/core'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { useTrans } from '../../../services/i18n'

const ROWS_PER_PAGE = [10, 25, 50, 100]

const useStyles = makeStyles({
  root: { padding: '12px 40px' },
  select: {
    marginLeft: 12,
    minWidth: 64,
    borderRadius: 12,
    '& .MuiSelect-outlined': { paddingTop: 8, paddingBottom: 8 },
  },
  navButton: {
    border: '1px solid #eaebef',
    padding: 6,
  },
})

const PaginationFooter = ({ page, perPage, count, pending, onChangePage, onChangeRowPerPage }) => {
  const { trans } = useTrans()
  const styles = useStyles()
  const countPages = Math.max(1, Math.ceil(count / perPage))
  const from = count === 0 ? 0 : (page - 1) * perPage + 1
  const to = Math.min(page * perPage, count)

  return (
    <Grid container className={styles.root} alignItems="center" justifyContent="space-between">
      <Grid item>
        <Typography variant="body2" component="span">
          {trans('rows-per-page')}
        </Typography>
        <Select
          className={styles.select}
          variant="outlined"
          value={perPage}
          disabled={pending}
          onChange={(e) => onChangeRowPerPage(e.target.value)}
        >
          {ROWS_PER_PAGE.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      <Grid item>
        <Grid container alignItems="center" spacing={1}>
          <Grid item>
            <Typography variant="body2">{`${from}–${to} of ${count}`}</Typography>
          </Grid>
          <Grid item>
            <IconButton
              className={styles.navButton}
              aria-label="previous page"
              disabled={pending || page <= 1}
              onClick={() => onChangePage(page - 1)}
            >
              <ChevronLeftIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <Typography variant="body2">{`Page ${page} of ${countPages}`}</Typography>
          </Grid>
          <Grid item>
            <IconButton
              className={styles.navButton}
              aria-label="next page"
              disabled={pending || page >= countPages}
              onClick={() => onChangePage(page + 1)}
            >
              <ChevronRightIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

PaginationFooter.propTypes = {
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  pending: PropTypes.bool,
  onChangePage: PropTypes.func.isRequired,
  onChangeRowPerPage: PropTypes.func.isRequired,
}

export default PaginationFooter
